module.exports = __webpack_public_path__ + "media/site/images/icons/shoot-arrow-icon-74723e3ed53f2aef810f8eeaa62bc0ea.svg";